<template>
  <div>
    <div class="bg-white pb-50" v-if="detailData">
      <div class="container mx-auto">
        <div class="py-20">
          <a-breadcrumb separator=">">
            <a-breadcrumb-item>
              <a href="/">首页</a>
            </a-breadcrumb-item>
            <a-breadcrumb-item>{{ detailData.name }}</a-breadcrumb-item>
          </a-breadcrumb>
        </div>

        <div class="flex">
          <div class="ss-lesson-cover-img flex-none">
            <img :src="detailData.image" class="object-cover" alt/>
          </div>
          <div class="pl-30">
            <div class="text-30 text-gray-900 mb-20">{{ detailData.name }}</div>
            <div class="text-14 text-gray-501 mb-25">
              {{ detailData.exname }}
            </div>

            <!--<div class="ss-lesson-hot bg-red-201 text-12 gray-900 px-12 py-10">-->
            <!--<span></span>-->
            <!--<span>将于<span class="text-red-501">2020年09月01日00:00</span>关闭优惠，仅剩<span class="text-red-501">945</span>名额</span>-->
            <!--</div>-->

            <div class="ss-lesson-money bg-gray-200">
              <div class="flex items-center justify-between px-20 py-5">
                <!-- <div
                    class="flex items-center"
                    v-if="detailData.price > 0 && detailData.is_pay == 0"
                >
                  <div class="pr-20 text-12 text-gray-501">价格</div>
                  <div>
                    <span class="text-orange-501 text-12">￥</span>
                    <span
                        class="text-orange-501 text-30 font-bold"
                        v-if="detailData.price > 0"
                    >{{ detailData.price }}</span
                    >
                    <span class="text-orange-501 text-30 font-bold" v-else
                    >免费</span
                    >
                    <span class="line-through text-12 text-gray-501"
                    >￥{{ detailData.price_line }}</span
                    >
                  </div>
                </div> -->
                <!-- <div class="flex items-center" v-else>
                  <div>
                    <span class="text-orange-501 text-30 font-bold"
                    >已拥有</span
                    >
                  </div>
                </div> -->
                <div>
                  <span class="text-gray-501 text-12"
                  >{{ detailData.look_num }}人浏览</span
                  >
                </div>
              </div>
            </div>

            <div
                class="flex mt-25"
                v-if="detailData.price > 0 && detailData.is_pay == 0"
            >
              <!-- 去付款之前的内容 -->
              <!-- <Pay :params="{content_type:0, is_team:0, content_id: id}">
                <div class="text-12 bg-orange-501 text-white px-80 py-15 text-15 cursor-pointer">立即购买</div>
              </Pay>-->
              <!-- 去付款之前的内容 -->
              <!-- 去付款之后的内容 -->
              <div
                  class="text-12 bg-orange-501 text-white px-80 py-15 text-15 cursor-pointer"
                  @click="toBuyIt(id)"
              >
                立即购买
              </div>
              <!-- 去付款之后的内容 -->
            </div>

            <div
                class="flex mt-25"
                v-else-if="!(detailData.price > 0 && detailData.is_pay == 0)"
            >
              <div
                  class="text-12 bg-green-500 text-white px-80 py-15 text-15 cursor-pointer"
                  @click="toLessonList()"
              >
                立即学习
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-40 mb-100">
      <div class="container mx-auto">
        <div class="flex justify-between">
          <div class="ss-lesson-cont-l bg-white px-30 py-20 ss-center-box">
            <div>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="课程介绍">
                  <div class v-html="detailData.introduce"></div>
                </a-tab-pane>

                <a-tab-pane
                    key="2"
                    tab="课程目录"
                    force-render
                    v-if="is_course == 1"
                >
                  <div>
                    <a-collapse :bordered="false" :activeKey="activeKey">
                      <a-collapse-panel
                          :key="o_index + ''"
                          :header="o_item.section_name"
                          v-for="(o_item, o_index) in detailData.sections"
                      >
                        <ul>
                          <li
                              v-for="(t_item, t_index) in o_item.sub_section"
                              :key="t_index"
                              class="mt-5 mb-5 cursor-pointer"
                              @click="toLessonDetail()"
                          >
                            <div
                                class="p-10 text-12 text-gray-900 flex items-center ss-study-item"
                            >
                              <span
                                  :class="`iconfont icon-t_${type} text-gray-501 text-20`"
                              ></span>
                              <span class="pl-5">{{ t_item.name }}</span>
                            </div>
                          </li>
                        </ul>
                      </a-collapse-panel>
                    </a-collapse>
                  </div>
                </a-tab-pane>
                <!-- <a-tab-pane key="3" tab="问答交流">
                  <comment :lesson-id="id" :is-pay="isPay"></comment>
                </a-tab-pane> -->
              </a-tabs>
            </div>
          </div>
          <div class="ss-lesson-cont-r self-start">
            <!-- <div
              class="bg-white px-30 pt-20 pb-30"
              v-if="detailData.teachers_info.length > 0"
            >
              <div
                class="text-18 text-gray-900 mb-20 ss-lesson-cont-r-teacher pl-15"
              >
                授课老师
              </div>
              <div
                class="flex py-10 cursor-pointer"
                v-for="(item, index) in detailData.teachers_info"
                :key="index"
                @click="goToAboutTeacher(item)"
              >
                <div class="w-72 h-72 rounded-full flex-none">
                  <img
                    class="ss-lesson-cont-r-teacher-img rounded-full"
                    :src="item.avatarUrl || mr_tx"
                    alt
                  />
                </div>
                <div class="ml-15">
                  <div class="text-16 text-gray-900 pb-10">{{ item.name }}</div>
                  <div class="text-12 text-gray-501">{{ item.desc }}</div>
                </div>
              </div>
            </div> -->

            <div
                class="bg-white px-30 pt-20 pb-30"

            >
              <div
                  class="text-18 text-gray-900 mb-20 ss-lesson-cont-r-teacher pl-15"
              >
                相关课程
              </div>
              <div
                  class="py-10 cursor-pointer hover:text-blue-501"
                  v-for="(item, index) in detailData.about_content"
                  :key="index"
              >
                <div class="flex" @click="goToOtherLesson(item.id)">
                  <div class="w-120 h-80 flex-none">
                    <img
                        class="w-120 h-80 object-cover"
                        :src="item.image"
                        alt
                    />
                  </div>
                  <div class="ml-15">
                    <div class="text-14 text-gray-900 ss-ellipsis2">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailData: {}, // 详情数据
      id: 0, // 详情数据id
      sign: "", // 用于在支付时区别类别 当前直播
      is_course: 0, // 0 单课程 1 章节课程
      type: 0, // 课程类型 1： 图文 2：视频 3：语音
      mr_tx: "https://qxystatic.qingxiaoyun.com/qxy/20200807/5f2d25ab58753.png", // 默认头像
      training_plan_id:0,//培训计划页面跳转过来传的参数
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.training_plan_id=this.$route.query.training_plan_id
    console.log(this.training_plan_id,'this.training_plan_id')
    this.getLessonContent();
  },
  methods: {
    // 获取课程详情列表
    async getLessonContent() {
      const {data: res} = await this.$http.get(
          "index.php/internal/lore_content_api/detail",
          {
            id: this.id,
          }
      );
      console.log(res, "aa");
      this.detailData = res;
      this.is_course = res.is_course;
    },
    // 去其他相关课程
    goToOtherLesson(id) {
      this.$router.push({path: `/lesson/lessonList?id=${id}`});
      setTimeout(() => {
        this.$router.go(0);
      }, 50);
    },
    // 去课程整体详情
    toLessonList() {
    
      if (this.is_course == 0) {
        this.$router.push({path: `/lesson/lessonDetail?id=${this.id}&training_plan_id=${this.training_plan_id}`}); // 单课程的查看
      } else if (this.is_course == 1) { //章节课程的
        // 章节课程
        if (this.detailData.sections.length > 0) {
          this.$router.push({path: `/lesson/${this.id}?`}); 
        } else {
          this.$message.info('课程暂无内容，请联系管理员添加')
        }
      }
    },
    toLessonDetail() {
      // 去课程章节详情

      if (this.is_course == 0) {
        this.$router.push({path: `/lesson/lessonDetail?id=${this.id}`}); // 单课程的查看
      } else if (this.is_course == 1) {//章节课程的
        this.$router.push({
          path: `/lesson/${this.id}?`,
        });
      }
    },

  },
  computed: {
    isPay() {
      // 是否需要付费,价格大于零并且未付费
      if (this.detailData.is_pay == 0 && this.detailData.price > 0) {
        return true;
      } else {
        return false;
      }
    },
    activeKey() {
      // 折叠
      var n = this.detailData.sections.length;
      var arr = [];
      for (var i = 0; i < n; i++) {
        arr.push(i + "");
      }
      return arr;
    },
  },
};

// var d:any = {}
// var s:any = {}

// @Component({
//   async asyncData(app: any) {
//     const id = app.query.id;
//     const res_1 = await app.$axios.$get("gw_pcschool/content_detail", {
//       params: { id },
//     });

//     d = res_1.data
//     s = app.store.state.seo

//     if (res_1 && res_1.code == 200) {
//       return {
//         detailData: res_1.data,
//         type: res_1.data.type,
//         is_course: res_1.data.is_course,
//         id,
//       };
//     } else if (res_1 && res_1.code == 400) {
//       setTimeout(() => {
//         app.app.router.go(-1);
//       }, 100);
//     }
//   },
//   head() {
//     return {
//       title:  d.name + '-' + s.seo_title ,
//       meta: [
//         {
//           name: 'keywords',
//           content: '课程'
//         },
//         {
//           name: 'description',
//           content: d.exname
//         }
//       ]
//     }
//   }
// })
// export default class lessonDetail extends Vue {
//   private detailData: any = {}; // 详情数据
//   private id: number = 0; // 详情数据id
//   private sign: string = ""; // 用于在支付时区别类别 当前直播
//   private is_course: number = 0; // 0 单课程 1 章节课程
//   private type: number = 0; // 课程类型 1： 图文 2：视频 3：语音
//   private mr_tx: string = "https://qxystatic.qingxiaoyun.com/qxy/20200807/5f2d25ab58753.png"; // 默认头像
//   @State("xtoken") stateXtoken: any; // 用户token
//   @State("seo") stateSeo: any; // seo
//   @Mutation("openLogin") mutationOpenLogin: | ((arg0: boolean) => void) | undefined; // 打开登录弹框
//   @Mutation("openPay") mutationOpenPay: ((arg0: boolean) => void) | undefined; // 打开支付弹框
//   $axios: any;
//   $message: any;

//   mounted() {
//   }

//   goToAboutTeacher(item:object){   // 点击老师，跳转到老师详情页
//     this.$router.push(`/teacher/teacherDetail?active=teacher&teacher_id=${(item as any).id}`)
//   }
//   toLessonDetail(content_id: number) {  // 去课程详情
//     if (!this.stateXtoken) {
//       (this as any).mutationOpenLogin(true); // 没有登录提示登录
//     } else if (this.detailData.price > 0 && this.detailData.is_pay === 0) {
//       this.$message.error({content:'还未购买此课程，无法进行学习哦！'})
//     } else {
//       if (this.is_course == 0) {
//         this.$router.push({ path: `/lesson/lessonDetail?id=${this.id}` }); // 单课程的查看
//       } else if (this.is_course == 1) {
//         this.$router.push({
//           path: `/lesson/${this.id}?content_id=${content_id}`,
//         });
//       }
//     }
//   }

//   toLessonList() { // 去详情
//     if (!this.stateXtoken) {
//       (this as any).mutationOpenLogin(true); // 没有登录提示登录
//     } else {
//       if (this.is_course == 0) {
//         this.$router.push({ path: `/lesson/lessonDetail?id=${this.id}` }); // 单课程的查看
//       } else if (this.is_course == 1) {
//         // 章节课程
//         if(this.detailData.sections.length>0){
//           this.$router.push({ path: `/lesson/${this.id}?` }); // 单课程的查看
//         }else{
//           this.$message.info('课程暂无内容，请联系管理员添加')
//         }
//       }
//     }
//   }

//   toBuyIt(id: number) {
//     // 去付款的购物车详情页
//     if (!this.stateXtoken) {
//       (this as any).mutationOpenLogin(true); // 没有登录提示登录
//     } else {
//       this.$router.push({ path: `/Payment/Cart?id=${this.id}&sign=lore` });
//     }
//   }
//   toMe(id: number) {
//     this.$router.push({ path: `/lesson/lessonList?id=${id}` });
//     setTimeout(() => {
//       this.$router.go(0);
//     }, 50);
//   }
// }
</script>


<style scoped>
.ss-lesson-money {
  width: 470px;
}

.ss-lesson-cover-img,
.ss-lesson-cover-img img {
  width: 450px;
  height: 280px;
  background: #eee;
}

.ss-lesson-cont-l {
  width: 890px;
}

.ss-lesson-cont-r {
  width: 290px;
}

.ss-lesson-cont-r-teacher {
  border-left: 4px solid #5173f5;
}

.ss-lesson-cont-r-teacher-img {
  width: 72px;
  height: 72px;
}

>>> .ant-collapse-borderless {
  background: none !important;
}

.ss-study-item {
  transition: all 0.3s;
}

.ss-study-item:hover {
  background: rgba(0, 0, 0, 0.05);
}
</style>
